import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

import Blank from "@/layouts/Blank.vue";
import Base from "@/layouts/Base.vue";
import Default from "@/layouts/Default.vue";
import Splash from "@/layouts/Splash.vue";
import Schedule from "@/layouts/Schedule.vue";

import Homepage from "@/views/Homepage.vue";
import Submenu from "@/views/Submenu.vue";
import SignIn from "@/views/SignIn.vue";
import SignUp from "@/views/SignUp.vue";
import UpdateUser from "@/views/UpdateUser.vue";
import ForgotPassword from "@/views/ForgotPassword.vue";
import ChangePassword from "@/views/ChangePassword.vue";
import Logout from "@/views/Logout.vue";
import UnderConstruction from "@/views/UnderConstruction.vue";
import TrafficMap from "@/views/TrafficMap.vue";
import NotFound from "@/views/NotFound.vue";
import BusSchedule from "@/views/BusSchedule.vue";
import AirSchedule from "@/views/AirSchedule.vue";
import BusTracker from "@/views/BusTracker.vue";
import TrainSchedule from "@/views/TrainSchedule";

export default new Router({
  mode: "history",

  routes: [
    {
      path: "",
      component: Base,
      children: [
        {
          path: "",
          component: Splash,
          children: [
            {
              path: "/",
              name: "Homepage",
              component: Homepage
            }
          ]
        },
        {
          path: "",
          component: Default,
          children: [
            {
              path: "",
              component: Schedule,
              children: [
                {
                  path: "bus-schedule",
                  name: "BusSchedule",
                  component: BusSchedule
                },
                {
                  path: "air-schedule",
                  name: "AirSchedule",
                  component: AirSchedule
                },
                {
                  path: "bus-tracker",
                  name: "BusTracker",
                  component: BusTracker
                },
                {
                  path: "traffic",
                  name: "TrafficMap",
                  component: TrafficMap
                },
                {
                  path: "train-schedule",
                  name: "TrainSchedule",
                  component: TrainSchedule
                }
              ]
            },
            {
              path: "/m/:slug",
              name: "Submenu",
              component: Submenu
            }
          ]
        }
      ]
    },
    {
      path: "",
      component: Blank,
      children: [
        {
          path: "signin",
          name: "SignIn",
          component: SignIn,
          meta: { noAuth: true }
        },
        {
          path: "signup",
          name: "SignUp",
          component: SignUp,
          meta: { noAuth: true }
        },
        {
          path: "updateuser",
          name: "UpdateUser",
          component: UpdateUser,
          meta: { isAuth: true }
        },
        {
          path: "forgotpassword",
          name: "ForgotPassword",
          component: ForgotPassword,
          meta: { noAuth: true }
        },
        {
          path: "changepassword",
          name: "ChangePassword",
          component: ChangePassword,
          meta: { isAuth: true }
        },
        {
          path: "logout",
          name: "Logout",
          component: Logout
        }
      ]
    },
    {
      path: "*",
      name: "NotFound",
      component: NotFound
    }
  ]
});
